import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'yearDate',
})
export class YearDatePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(date: string): SafeResourceUrl {
    // eslint-disable-next-line
    return date?.split(' ')[0];
  }
}
